module.exports = __webpack_public_path__ + "img/cat.5bbcd4c2.png";